<template>
	<div class="c-filter-radio-list" v-bind="$attrs">
		<span
			v-if="label"
			key="label"
			class="font-bold flex-shrink-0 flex-grow-0 -mr-[20px]"
		>
			{{ label }}:
		</span>

		<span
			v-for="option in options"
			:key="option.value"
			class="inline-flex items-center"
		>
			<label class="inline-flex items-center w-full h-full">
				<input
					type="radio"
					:name="name"
					:value="option.value"
					:checked="option.checked"
					class="c-filter-radio-list__input"
					@change="($event) => updateOptions($event.target.value)"
				/>
				<span v-if="option.label" class="ml-layout-gutter">
					{{ option.label }}
				</span>
			</label>
			<BaseDialog
				v-if="option.description || infoLookupTable[option.value]"
				v-slot="{ toggle }"
				title="Info"
				:text="option.description || infoLookupTable[option.value]"
			>
				<button
					class="ml-[4px] w-[13px] h-[13px] flex-shrink-0 text-orange"
					@click="toggle(true)"
				>
					<SvgIconInfo />
				</button>
			</BaseDialog>
		</span>
	</div>
</template>

<script setup>
import SvgIconInfo from '~/assets/svgs/icon-info.svg';
const emit = defineEmits(['update:modelValue', 'change']);
const props = defineProps({
	type: {
		type: String,
		default: 'text',
	},
	label: {
		type: String,
		default: null,
	},
	name: {
		type: String,
		default: null,
	},
	options: {
		type: Array,
		default: () => [],
	},
	infoLookupTable: {
		type: Object,
		default: () => ({}),
	},
	modelValue: {
		type: String,
		default: undefined,
	},
});

typeof props.modelValue !== 'undefined' && updateOptions(props.modelValue);

// Methods
function updateOptions(newValue) {
	props.options.forEach((option) => {
		if (option.value === newValue) {
			option.checked = true;
		} else {
			option.checked = false;
		}
	});
	const { value } = props.options.find((option) => option.checked) ?? {};

	emit('update:modelValue', value);
	process.client && emit('change', newValue);
}
</script>

<script>
export default {
	inheritAttrs: false,
};
</script>

<style lang="postcss">
.c-filter-radio-list {
	@apply relative flex items-baseline w-auto h-auto text-white gap-x-[40px] gap-y-layout-gutter;

	label {
		@apply cursor-pointer;
	}
}

.c-filter-radio-list__input {
	@apply appearance-none relative w-[14px] h-[14px] rounded-full border-2 border-white;

	&:checked:before {
		content: '';
		@apply absolute inset-[2px] rounded-full bg-white;
	}
	:hover > & {
		@apply border-orange;

		&:checked:before {
			@apply bg-orange;
		}
	}
}
</style>
